import { apiRequest } from "./util";

export async function handleEmail(method, data) {
  try {
      const response = await apiRequest('email', "POST", {
        action: method,
        data: data
      })
      return(response)
  } catch (error) {
      console.error('Error:', error)
      throw error
  }
}
